import { TyreSelectByIdOutputData } from './tyre-select-by-id-output-data.model';


export class TyreSelectByIdOutput implements ITyreSelectByIdOutput {
    status!: number;
    message!: string;
    data!: TyreSelectByIdOutputData;

    constructor(data?: ITyreSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? TyreSelectByIdOutputData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TyreSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TyreSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITyreSelectByIdOutput {
    status: number;
    message: string;
    data: TyreSelectByIdOutputData;
}

